<template>
    <div class="content-area">
        <div class="center">
            <div>
                <div class="down">
                    <img src="/resources/png/18.png" />
                </div>
                <div data-qa="contact-record-text">
                    <h2>
                        Yes, the contact record<br />
                        is now customizable
                    </h2>
                </div>
            </div>

            <div class="center content">
                <p class="font">
                    Create custom layouts for the contact record that fit the<br />
                    needs of you and your employees. Select a layout from the left<br />
                    or create a new layout to get started.
                </p>
                <ds-filled-button
                    type="submit"
                    data-qa="filled-submit-button"
                    @click="addLayout"
                >
                    Create a new layout
                </ds-filled-button>
                <p class="font">
                    Or start from a pre-built layout<br />
                    (on the left)
                </p>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    methods: {
        addLayout() {
            this.$root.$emit('BUTTON_ADD_LAYOUT', true);
        },
    },
};
</script>
<style lang="scss" scoped>
.layout {
    display: flex;
}

.create-new-layout{
    text-align: center;
}

.center {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 100%;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 1rem;
    padding-top: 3.75rem;
}

.content {
    color: $color-gray-80;
    margin-bottom: 8rem;
    font-size: $small;
}

.down {
    margin: $spacing-600;
}

.label {
    font-size: $font-size-jumbo;
    margin-top: $spacing-400;
}

.content-area {
    flex: 1;
    width: 70%;
    position: absolute;
    -webkit-overflow-scrolling: auto !important;
    overflow-y: auto;
    height: 100vh;
}
</style>
